import { GridRenderCellParams } from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";
import { TableRow, DataRow } from "../types";
import CompetitorPresenceChip from "../CompetitorPresenceChip";
import { CompetitorPresenceTooltip } from "../CompetitorPresenceTooltip";
import WorkSpaceStyledTooltip from "../../../Header/SelectedMarketFilters/WorkSpaceStyledTooltip";

interface CompetitorPresenceCellProps extends GridRenderCellParams<TableRow> {
  competitorProductMetadata: Record<number, string>;
  hasCompetitorPresence: boolean;
}

export const CompetitorPresenceCell = (params: CompetitorPresenceCellProps) => {
  if (params.row.isSkeleton) {
    return <Skeleton variant="text" width="100%" />;
  }

  const rowData = params.row as DataRow;
  const competitorPresenceIds = rowData.competitorPresence || [];

  // Get product names for tooltip
  const productNames = competitorPresenceIds
    .map((id) => params.competitorProductMetadata[id])
    .filter(Boolean);

  const chipComponent = (
    <CompetitorPresenceChip
      hasCompetitorPresence={params.hasCompetitorPresence}
      competitorPresenceIds={competitorPresenceIds}
      competitorProductMetadata={params.competitorProductMetadata}
    />
  );

  // If there are products to show in tooltip, wrap with tooltip
  if (productNames.length > 0) {
    return (
      <WorkSpaceStyledTooltip
        title={<CompetitorPresenceTooltip products={productNames} />}
        placement="left"
        arrow
      >
        <div>{chipComponent}</div>
      </WorkSpaceStyledTooltip>
    );
  }

  return chipComponent;
};
